export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.body && !(init.body instanceof FormData) && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  const response = await fetch(url, { ...init, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw Object.assign(new Error(data.message || "요청을 처리하지 못했어요"), { status: response.status, code: data.error_code });
  }
  return data as T;
}

export function requestId() {
  return crypto.randomUUID();
}

export function formatTime(value: string) {
  return new Intl.DateTimeFormat("ko-KR", { hour: "2-digit", minute: "2-digit" }).format(new Date(value));
}

export function analysisLabel(status: string) {
  if (status === "pending" || status === "running") return "분석 중";
  if (status === "complete") return "분석 완료";
  if (status === "partial") return "일부만 확인";
  if (status === "failed") return "분석 실패";
  if (status === "skipped") return "원본만 보관";
  return status;
}
